export const home = '/'
export const login = '/login'
export const register = '/register'
export const resetPassword = '/reset-password'
export const createCV = '/create-cv'
export const record = '/record'
export const settings = '/accountsettings'
export const support='/support'
export const privacyPolicyUrl='https://docs.google.com/document/u/1/d/e/2PACX-1vSaq3iDO_I1tdqh_9IgJQzwyIqpCNLcL9_Zb36i1kSXfIz_SCo_3ragov0EyXLEP8HpkQv1BiW_ntkR/pub'
